import {
  Divider,
  FormControl,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";

import { Section } from "@/components/Section";
import { FormCheckbox } from "@/components/FormCheckbox";
import { PaymentEditor } from "@/components/Payment/PaymentEditor";

import { PurchaseMembershipEditor } from "../../components/PurchaseMembershipEditor";
import { PurchaseProductPTEditor } from "../../components/PurchaseProductPTEditor";
import { FormSummaryPriceDetail } from "../../components/FormSummaryPriceDetail";

import type { Control, UseFormReset } from "react-hook-form";
import type { PurchaseMembershipEditorState } from "../../components/PurchaseMembershipEditor";
import type { PurchaseProductPTEditorState } from "../../components/PurchaseProductPTEditor";
import type { PaymentEditorState } from "@/components/Payment/PaymentEditor";

type PurchaseProductEditorProps = {
  membershipControl: Control<PurchaseMembershipEditorState>;
  packagePTControl: Control<PurchaseProductPTEditorState>;
  paymentFormControl: Control<PaymentEditorState>;
  packagePTReset: UseFormReset<PurchaseProductPTEditorState>;
};

export function PurchaseProductEditor({
  membershipControl,
  packagePTControl,
  paymentFormControl,
  packagePTReset,
}: PurchaseProductEditorProps) {
  return (
    <Stack gap={4}>
      <Section columns={1} label={`ซื้อแพ็กเกจสมาชิก`}>
        <PurchaseMembershipEditor control={membershipControl} />
      </Section>
      <Divider />
      <Stack gap={2.5}>
        <Stack direction="row" gap={1.25} alignItems="center">
          <Typography variant="labelLarge">ซื้อแพ็กเกจเทรนเนอร์</Typography>
          <FormControl sx={{ width: 140 }}>
            <FormControlLabel
              control={
                <FormCheckbox name="required" control={packagePTControl} />
              }
              label="ต้องการซื้อ"
              labelPlacement="end"
            />
          </FormControl>
        </Stack>
        <PurchaseProductPTEditor
          control={packagePTControl}
          reset={packagePTReset}
        />
      </Stack>
      <Divider />
      <PaymentEditor control={paymentFormControl} />
      <FormSummaryPriceDetail
        membershipControl={membershipControl}
        packagePTControl={packagePTControl}
      />
    </Stack>
  );
}
